import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
const DROP_ID = '4f56c2ef-5f9f-4a1b-a02b-9ce960c9e247';
export function Tour() {
  return <section id="tour" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-93">
      <SectionHeader number="01" title="Live Dates" data-id="element-94" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="w-full max-w-[1000px] mx-auto" data-id="element-95">
        <div className="overflow-hidden rounded-lg bg-white" data-id="element-96">
          <iframe id={`laylo-drop-${DROP_ID}`} frameBorder="0" scrolling="no" allow="web-share" allowTransparency title="RuslanSilvr — FLO Tour" className="block w-full min-h-[560px] md:min-h-[640px]" style={{
          maxWidth: '1000px'
        }} src={`https://embed.laylo.com?dropId=${DROP_ID}&color=f93434&minimal=false&theme=light`} data-id="element-97" />
        </div>

        <div className="flex justify-between items-center gap-1 px-4 py-3 mt-2" data-id="element-98">
          <a href={`https://laylo.com/ruslansilvr?utm_source=multidropEmbed&utm_campaign=${DROP_ID}&utm_medium=profileLink`} target="_blank" rel="noopener noreferrer" className="text-[10px] tracking-wide text-brand-muted underline decoration-dotted underline-offset-2 hover:text-brand-white transition-colors" data-id="element-99">
            Follow RuslanSilvr
          </a>
          <a href={`https://laylo.com/d/${DROP_ID}?utm_source=multidropEmbed&utm_campaign=${DROP_ID}&utm_medium=multridropLink`} target="_blank" rel="noopener noreferrer" className="text-[10px] tracking-wide text-brand-muted underline decoration-dotted underline-offset-2 hover:text-brand-white transition-colors" data-id="element-100">
            View on Laylo
          </a>
        </div>
      </motion.div>
    </section>;
}